import { render, staticRenderFns } from "./BtnInserirDotacaoEmMassa.vue?vue&type=template&id=05233d3d"
import script from "./BtnInserirDotacaoEmMassa.vue?vue&type=script&lang=js"
export * from "./BtnInserirDotacaoEmMassa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports